import * as Solr from "../../../3x1010/Solr.js";

export default class WrapperIO {
  static saveQuery(qb, res, callback) {
    const query = Solr.QueryWrapper.toJsonObject(qb.getQuery(), qb.getCollection());
    const rq = {
      Data: {
        Uid: res.uid,
        Name: res.name,
        Description: res.desc,
        Query: JSON.stringify(query),
        Collection: qb.getCollection(),
      },
    };
    thatServiceManager.standardCall("/api/app/query/update", rq, this.handleSaveQuery.bind(this, callback));
  }

  static handleSaveQuery(callback, rs) {
    if (rs) {
      if (rs.Success) {
        callback.call(null, { type: WrapperIO.EVENT_SAVED_SUCCESS, uid: rs.Data });
      } else {
        alert("Errore durante il salvataggio della query");
        callback.call(null, { type: WrapperIO.EVENT_SAVED_ERROR });
      }
    }
  }

  static hasSaves() {
    return true;
    //return localStorage.getItem("queries") !== null;
  }

  static getQueries(callback) {
    const rq = null;
    thatServiceManager.standardCall("/api/app/query", rq, this.handleGetQueries.bind(this, callback), "GET");
  }

  static handleGetQueries(callback, rs) {
    if (rs) {
      if (rs.Success) {
        callback.call(null, { type: WrapperIO.EVENT_LOAD_SUCCESS, queries: rs.Items });
      } else {
        alert("Errore durante il caricamento delle query");
        callback.call(null, { type: WrapperIO.EVENT_LOAD_ERROR });
      }
    }
  }

  static deleteQuery(uid, callback) {
    /*const queries = JSON.parse(localStorage.getItem("queries")) || [];
    const newQueries = queries.filter((q) => q.name !== name);
    localStorage.setItem("queries", JSON.stringify(newQueries));
    if (callback) {
      setTimeout(() => {
        callback.call(null, newQueries);
      }, WrapperIO.SIMULATED_DELAY);
    }*/
    const rq = null;
    thatServiceManager.standardCall("/api/app/query/delete/" + uid, rq, this.handleDeleteQuery.bind(this, callback), "POST");
  }

  static handleDeleteQuery(callback, rs) {
    if (rs) {
      if (rs.Success) {
        this.getQueries(callback);
      } else {
        alert("Errore durante l'eliminazione della query");
        callback.call(null, { type: WrapperIO.EVENT_SAVED_ERROR });
      }
    }
  }
}

WrapperIO.EVENT_SAVED_SUCCESS = "savedSuccess";
WrapperIO.EVENT_SAVED_ERROR = "savedError";
WrapperIO.EVENT_LOAD_SUCCESS = "loadSuccess";
WrapperIO.EVENT_LOAD_ERROR = "loadError";
WrapperIO.SIMULATED_DELAY = 100;
